import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import {
  CopyToClipboardModule,
  DropdownModule,
  icoApple,
  icoArrowDownCircleDuo,
  icoEclipseBranded,
  icoEnvelope,
  icoFile,
  icoLauncherBranded,
  icoLinkExternalDuo,
  icoLinux,
  IconsModule,
  icoShareFilled,
  icoWindows,
  LinkModule,
  TooltipModule,
  VisibleInputModule
} from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { DownloadButtonGroupComponent } from './download-button-group/download-button-group.component';
import { LicenseValidityDatePipe } from './license-validity/license-validity-date.pipe';
import { LicenseValidityDurationPipe } from './license-validity/license-validity-duration.pipe';
import { LicenseValidityEndDatePipe } from './license-validity/license-validity-end-date.pipe';
import { LicenseValidityComponent } from './license-validity/license-validity.component';
import { LimitedTermPipe } from './limited-term.pipe';
import { RemoveUrlProtocolPipe } from './remove-url-protocol.pipe';
import { SubscriptionIntervalPipe } from './subscription-interval.pipe';

@NgModule({
  declarations: [
    DownloadButtonGroupComponent,
    LicenseValidityComponent,
    LicenseValidityDatePipe,
    LicenseValidityDurationPipe,
    LicenseValidityEndDatePipe,
    LimitedTermPipe,
    RemoveUrlProtocolPipe,
    SubscriptionIntervalPipe
  ],
  imports: [
    CopyToClipboardModule,
    CommonModule,
    DropdownModule,
    IconsModule.withIcons(
      icoApple,
      icoArrowDownCircleDuo,
      icoEclipseBranded,
      icoEnvelope,
      icoFile,
      icoLauncherBranded,
      icoLinkExternalDuo,
      icoLinux,
      icoShareFilled,
      icoWindows
    ),
    LinkModule,
    MatomoTrackClickDirective,
    RouterExtensionsModule,
    RouterModule,
    TranslocoMarkupModule,
    TranslocoModule,
    TranslocoLocaleModule,
    TooltipModule,
    VisibleInputModule
  ],
  exports: [DownloadButtonGroupComponent, LicenseValidityComponent, LimitedTermPipe, SubscriptionIntervalPipe]
})
export class MarketplaceProductModule {}
